import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { Dropdown } from 'semantic-ui-react'

const DropdownSection = styled.span`
  span {
    margin-right: 10px;
  }
`

export class FrequencySetting extends React.Component {
  static propTypes = {
    defaultValue: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
      })
    ).isRequired,
  }

  static defaultProps = {
    onSelect: () => this.props.defaultValue || 0,
  }

  handleValueChange = (_, { value }) => {
    this.props.onSelect(value)
  }

  render() {
    const { defaultValue, options } = this.props
    return (
      <React.Fragment>
        <h3>Frequency</h3>
        <DropdownSection>
          <span>Send every</span>
          <Dropdown
            defaultValue={defaultValue}
            onChange={this.handleValueChange}
            options={options}
            placeholder="Select Frequency"
            scrolling={false}
            selection
          />
        </DropdownSection>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/FrequencySetting/index.js